import { WorkflowTemplateStatus } from '../Types'

const blank: WorkflowTemplateStatus = {
  configuration: {
    'c8a1feab-d2f6-421a-952d-99a57e65c6d4': {
      exit: [],
      entry: [],
    },
    '61c12d8e-0cb4-4fb7-a007-1dbd64b5d215': {
      exit: [],
      entry: [],
    },
    'f2241fb4-92a6-11ee-b9d1-0242ac120002': {
      exit: [],
      entry: [],
    },
  },
  property_values: [
    {
      uuid: 'c8a1feab-d2f6-421a-952d-99a57e65c6d4',
      value: 'Draft',
      meta: {
        color: '#E5ECF3',
      },
      position: 0,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '61c12d8e-0cb4-4fb7-a007-1dbd64b5d215',
      value: 'Final',
      meta: {
        color: '#028C3A',
      },
      position: 1,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: 'f2241fb4-92a6-11ee-b9d1-0242ac120002',
      value: 'Posted',
      meta: {
        color: '#0026AD',
      },
      position: 2,
      connected_to_uuid: null,
      connected_to_id: null,
    },
  ],
}

export default blank
